export default __webpack_public_path__ + "../staticImages/visa.svg";